import React, { useState, useEffect } from "react";

// importing styles
import "./hero-section-styles.scss";

// importing components
import { RiSendPlaneFill } from "react-icons/ri";
import ButtonComponent from "../../components/button-component/button-component";

const HeroSection = () => {
	// i want to add fade text animation to the slider-role class. it should change from "Designer" to "Writer" to "Creator". help me achieve this. now i want to add a fade in animaition to the slider-role class. it should fade in from the top side. help me achieve this.

	const roles = ["Designer", "Writer", "Creator"];
	const [rolesText, setRolesText] = useState(roles[0]);

	useEffect(() => {
		let i = 0;
		const interval = setInterval(() => {
			if (i < roles.length - 1) {
				i++;
			} else {
				i = 0;
			}
			setRolesText(roles[i]);
		}, 3000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	return (
		<section id="hero-section" className="hero-section">
			{/* hero section */}
			<div className="hero-section-content-wrapper">
				<h4 className="hero-sub-heading">Moazam Ali</h4>
				<h2 className="role role-divider">Developer</h2>

				<h2 className={`slider-role role`}>
					<span className="plus-sign">+</span> {rolesText}
				</h2>

				<ButtonComponent
					newTab="false"
					btnLink="/#contact-section"
					icon={<RiSendPlaneFill />}
					text="Say Hello"
				/>
			</div>
		</section>
	);
};

export default HeroSection;
